// src/pages/Diagnosis.tsx

import React, { useState, useEffect } from 'react';
import QuestionComponent from '../components/Question';
import { useNavigate } from 'react-router-dom';
import { Question, DiagnosisType, UserAnswers } from '../types';
import { loadQuestions } from '../data/questions';
import diagnosisTypes from '../data/diagnosisTypes';

const Diagnosis: React.FC = () => {
  const [answers, setAnswers] = useState<UserAnswers>({});
  const navigate = useNavigate();
  const [questions, setQuestions] = useState<Question[]>([]);
  useEffect(() => {
    loadQuestions().then((questions) => {
      window.scrollTo(0, 0);
      setQuestions(questions);
    });
  }, []);

  const handleAnswer = (questionId: number, answer: string) => {
    setAnswers(prev => ({ ...prev, [questionId]: answer }));
  };

  const calculateScores = (answers: UserAnswers, questions: Question[]) => {
    let horizontalScore = 0;
    let verticalScore = 0;
    let canBeSudachiType = true;

    questions.forEach((question) => {
      const answer = answers[question.id];
      const score = question.scores[answer] || 0;
      if (question.penaltyAnswer.includes(answer)) {
        canBeSudachiType = false;
      }

      if (question.axis === '横') {
        horizontalScore += score;
      } else if (question.axis === '縦') {
        verticalScore += score;
      }
    });

    if (horizontalScore > 15) {
      horizontalScore = 15;
    } else if (horizontalScore < -15) {
      horizontalScore = -15;
    }

    if (verticalScore > 15) {
      verticalScore = 15;
    } else if (verticalScore < -15) {
      verticalScore = -15;
    }

    return { horizontalScore, verticalScore, canBeSudachiType };
  };

  const determineType = (horizontal: number, vertical: number, diagnosisTypes: DiagnosisType[], canBeSudachiType: Boolean) => {
    for (const type of diagnosisTypes) {
      if (type.typeName == 'スダチタイプ' && !canBeSudachiType) {
        continue;
      }
      const [hMin, hMax] = type.horizontalRange;
      const [vMin, vMax] = type.verticalRange;

      if (horizontal >= hMin && horizontal <= hMax && vertical >= vMin && vertical <= vMax) {
        return type;
      }
    }
    return null;
  };

  const handleSubmit = () => {
    // 全ての質問に回答しているか確認
    if (Object.keys(answers).length !== questions.length) {
      alert('全ての質問に回答してください。');
      return;
    }
  
    const { horizontalScore, verticalScore, canBeSudachiType } = calculateScores(answers, questions);
    
    // スコアをコンソールにログ出力
    console.log('Horizontal Score:', horizontalScore);
    console.log('Vertical Score:', verticalScore);
  
    const type = determineType(horizontalScore, verticalScore, diagnosisTypes, canBeSudachiType);
  
    if (type) {
      navigate('/result', { state: { type, horizontalScore, verticalScore } });
    } else {
      alert('診断結果が見つかりませんでした。もう一度お試しください。');
    }
  };

  const progress = (Object.keys(answers).length / questions.length) * 100;

  return (
    <div className="container bg-white rounded-lg shadow-lg p-8">
      <h1 className="text-3xl font-bold mb-6 text-center text-indigo-600">子育てタイプ診断<br/>〜小学生版〜</h1>
      {/* プログレスバー */}
      <div className="w-full bg-gray-200 rounded-full h-4 mb-6">
        <div
          className="bg-indigo-600 h-4 rounded-full transition-all duration-300"
          style={{ width: `${progress}%` }}
        ></div>
      </div>
      <div className="space-y-8">
        {questions ? questions.map(question => (
          <QuestionComponent
            key={question.id}
            question={question}
            onAnswer={handleAnswer}
            selectedAnswer={answers[question.id] || ''}
          />
        )): <>ロード中</>}
      </div>
      <div className="flex justify-center mt-6">
        <button
          onClick={handleSubmit}
          className="bg-indigo-600 hover:bg-indigo-700 text-white font-semibold py-3 px-6 rounded-lg shadow-md transition transform hover:scale-105 duration-300"
        >
          診断する
        </button>
      </div>
    </div>
  );
};

export default Diagnosis;
